<template>
  <div>
    <!-- Continer Summary Section Start -->
    <div></div>
    <b-button
      v-if="allModuleId > 0"
      class="mb-1 mt-1"
      @click="showContainerModal(allModuleId)"
      size="xs"
      style="font-size: 0.675rem"
      >{{ this.PMC_CONTNO }} Event Summary</b-button
    >
    <b-modal
      no-close-on-esc
      no-close-on-backdrop
      size="xl"
      ref="Container-modal"
      hide-footer
      :title="Page_title"
    >
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <b-row>
        <b-col md="12">
          <b-button
            class="pull-right mb-1"
            v-if="ContainerList.length > 0"
            :disabled="ExcelBtnName != 'Export As Excel' ? true : false"
            @click="getReports('getJobContainerDetails', 'Export As Excel')"
            size="xs"
            style="font-size: 0.675rem"
            variant="warning"
          >
            {{ ExcelBtnName }}
            <b-spinner
              v-if="ExcelBtnName != 'Export As Excel'"
              small
              label="Small Spinner"
            ></b-spinner
          ></b-button>
          <div class="col-md-12 row table-wrapper-scroll-x my-custom-scrollbar">
            <b-table
              show-empty
              stacked="md"
              :items="ContainerList"
              :fields="Containerfields"
              :per-page="perPage"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection"
            >
              <template slot="SN" slot-scope="row0">
                <span>{{ row0.index + 1 + (currentPage - 1) * perPage }}</span>
                <span
                  v-if="row0.item.rollover_event_code == 1"
                  :class="{
                    alert: true,
                    'alert-danger-text': row0.item.rollover_event_code == 1,
                    blink: row0.item.rollover_event_code == 1,
                  }"
                  ><br />This Container No Rollover</span
                >
              </template>
            </b-table>
          </div>
        </b-col>
        <b-col cols="12" class="text-center">
          <b-button
            class="mt-3"
            variant="outline-danger"
            size="xs"
            style="font-size: 0.675rem"
            @click="hideContainerModal"
            >Close</b-button
          >
        </b-col>
      </b-row>
    </b-modal>
  </div>

  <!-- Continer Summary Section End -->
</template>

<script>
import DatePicker from "vue2-datepicker";
// import Loading from "vue-loading-overlay";
import CustomLoader from "./customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { ModelListSelect } from "vue-search-select";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import CommonService from "../../services/CommonService.js";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";

export default {
  props: {
    PMC_title: {
      type: String,
      default: "",
    },
    PMC_JOBID: {
      type: String,
      default: "",
    },
    PMC_JOBNO: {
      type: String,
      default: "",
    },
    PMC_CONTNO: {
      type: String,
      default: "",
    },
    PMC_JOBDATE: {
      type: String,
      default: "",
    },
    PMC_JOBTYPE: {
      type: String,
      default: "",
    },
    PMC_AgentType: {
      type: String,
      default: "",
    },
    PMC_Client: {
      type: String,
      default: "",
    },
    PMC_Sline: {
      type: String,
      default: "",
    },
  },
  beforeMount() {
    if (this.PMC_JOBID && this.PMC_CONTNO) {
      // this.getContainer();
    }
  },
  mounted() {},

  data() {
    return {
      Page_title: this.PMC_title,
      isLoading: false,
      totalRows: 0,
      currentPage: 1,
      perPage: 300,
      pageOptions: [100, 200, 300],
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      Containerfields: [
        {
          key: "SN",
          mainkey: "SN",
          label: "SN.",
          sortable: true,
          sortDirection: "ASC",
          table: "A.",
        },
        {
          key: "shipment_id",
          mainkey: "shipment_id",
          label: "Shipment ID",
          sortable: true,
          sortDirection: "ASC",
          table: "B.",
        },
        {
          key: "subscription_id",
          mainkey: "subscription_id",
          label: "Subscription ID",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "SOB",
          mainkey: "SOB",
          label: "SOB",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "status_verbose",
          mainkey: "status_verbose",
          label: "Conatiner Status",
          sortable: true,
          sortDirection: "ASC",
          table: "D.",
        },
        {
          key: "pod_timeofarrival_warning_risk_verbose",
          mainkey: "pod_timeofarrival_warning_risk_verbose",
          label: "Risk Status",
          sortable: true,
          sortDirection: "ASC",
          table: "D.",
        },
        {
          key: "pod_timeofarrival_warning_risk_description",
          mainkey: "pod_timeofarrival_warning_risk_description",
          label: "Risk Desc",
          sortable: true,
          sortDirection: "ASC",
          table: "D.",
        },
        {
          key: "pod_timeofarrival_warning_conclusion",
          mainkey: "pod_timeofarrival_warning_conclusion",
          label: "Risk Conclusion",
          sortable: true,
          sortDirection: "ASC",
          table: "D.",
        },
        {
          key: "event_details_milestone",
          mainkey: "event_details_milestone",
          label: "Event Milestone",
          sortable: true,
          sortDirection: "ASC",
          table: "D.",
        },
        {
          key: "event_details_new_date",
          mainkey: "event_details_new_date",
          label: "Event Date",
          sortable: true,
          sortDirection: "ASC",
          table: "D.",
        },
        {
          key: "event_details_message",
          mainkey: "event_details_message",
          label: "Event MSG",
          sortable: true,
          sortDirection: "ASC",
          table: "E.",
        },
        {
          key: "event_code",
          mainkey: "event_code",
          label: "Event Code",
          sortable: true,
          sortDirection: "ASC",
          table: "F.",
        },
        {
          key: "event_severity",
          mainkey: "event_severity",
          label: "Event Severity",
          sortable: true,
          sortDirection: "ASC",
          table: "G.",
        },

        {
          key: "pod_timeofarrival_warning_milestone",
          mainkey: "pod_timeofarrival_warning_milestone",
          label: "POD Time Arrival",
          sortable: true,
          sortDirection: "ASC",
          table: "H.",
        },
        {
          key: "pod_timeofarrival_warning_predicted_time_of_arrival",
          mainkey: "pod_timeofarrival_warning_predicted_time_of_arrival",
          label: "POD Predicted",
          sortable: true,
          sortDirection: "ASC",
          table: "I.",
        },
        {
          key: "shipment_tsp1_loc_name",
          mainkey: "shipment_tsp1_loc_name",
          label: "TSP1 Location",
          sortable: true,
          sortDirection: "ASC",
          table: "J.",
        },
        {
          key: "tsp1_vslarrival_prediction",
          mainkey: "tsp1_vslarrival_prediction",
          label: "TSP1 Prediction",
          sortable: true,
          sortDirection: "ASC",
          table: "J.",
        },
        {
          key: "tsp1_vslarrival_planned_initial",
          mainkey: "tsp1_vslarrival_planned_initial",
          label: "TSP1 Planned Initial",
          sortable: true,
          sortDirection: "ASC",
          table: "K.",
        },
        {
          key: "tsp1_vslarrival_planned_last",
          mainkey: "tsp1_vslarrival_planned_last",
          label: "TSP1 Planned Last",
          sortable: true,
          sortDirection: "ASC",
          table: "L.",
        },
        {
          key: "tsp1_vslarrival_actual",
          mainkey: "tsp1_vslarrival_actual",
          label: "TSP1 Actual",
          sortable: true,
          sortDirection: "ASC",
          table: "M.",
        },
        {
          key: "tsp1_vslarrival_detected",
          mainkey: "tsp1_vslarrival_detected",
          label: "TSP1 Detected",
          sortable: true,
          sortDirection: "ASC",
          table: "N.",
        },
        {
          key: "tsp1_discharge_planned_initial",
          mainkey: "tsp1_discharge_planned_initial",
          label: "TSP1 Discharge Planned Initial",
          sortable: true,
          sortDirection: "ASC",
          table: "O.",
        },
        {
          key: "tsp1_discharge_planned_last",
          mainkey: "tsp1_discharge_planned_last",
          label: "TSP1 Discharge Planned Last",
          sortable: true,
          sortDirection: "ASC",
          table: "P.",
        },
        {
          key: "tsp1_discharge_actual",
          mainkey: "tsp1_discharge_actual",
          label: "TSP1 Discharge Actual",
          sortable: true,
          sortDirection: "ASC",
          table: "Q.",
        },
        {
          key: "tsp1_loaded_planned_initial",
          mainkey: "tsp1_loaded_planned_initial",
          label: "TSP1 Loaded Plan Initial",
          sortable: true,
          sortDirection: "ASC",
          table: "R.",
        },
        {
          key: "tsp1_loaded_planned_last",
          mainkey: "tsp1_loaded_planned_last",
          label: "TSP1 Loaded Plan Last",
          sortable: true,
          sortDirection: "ASC",
          table: "S.",
        },
        {
          key: "tsp1_loaded_actual",
          mainkey: "tsp1_loaded_actual",
          label: "TSP1 Loaded Actual",
          sortable: true,
          sortDirection: "ASC",
          table: "T.",
        },
        {
          key: "tsp1_vsldeparture_planned_initial",
          mainkey: "tsp1_vsldeparture_planned_initial",
          label: "TSP1 VSL Departure Plan Initial",
          sortable: true,
          sortDirection: "ASC",
          table: "U.",
        },
        {
          key: "tsp1_vsldeparture_planned_last",
          mainkey: "tsp1_vsldeparture_planned_last",
          label: "TSP1 VSL Departure Plan Last",
          sortable: true,
          sortDirection: "ASC",
          table: "V.",
        },
        {
          key: "tsp1_vsldeparture_actual",
          mainkey: "tsp1_vsldeparture_actual",
          label: "TSP1 VSL Departure Actual",
          sortable: true,
          sortDirection: "ASC",
          table: "W.",
        },
        {
          key: "tsp1_vsldeparture_detected",
          mainkey: "tsp1_vsldeparture_detected",
          label: "TSP1 VSL Departure Detected",
          sortable: true,
          sortDirection: "ASC",
          table: "X.",
        },
        {
          key: "created_at",
          mainkey: "created_at",
          label: "Created",
          sortable: true,
          sortDirection: "ASC",
          table: "X.",
        },
      ],
      ContainerList: [],
      allModuleId: this.PMC_JOBID,
      // isLoading: false,
      ExcelBtnName: "Export As Excel",
      docURL: URL_BASE_DOC,
    };
  },
  mounted() {},
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  beforeDestroy() {},

  destroyed() {},

  components: {
    // Loading,
    CustomLoader,
    DatePicker,
    ModelListSelect,
  },

  computed: {},
  watch: {
    JOBSERIES: {
      handler: function (newVal, oldVal) {
        this.getContainer("Normal");
      },
      deep: true,
    },
  },
  methods: {
    getReports(id, btnName) {
      this.ExcelBtnName = "Downloading Please Wait .....";
      this.getContainer("Excell");
    },
    getContainer(type) {
      this.webLog = [];
      let payload = {};
      if (this.PMC_JOBID && this.PMC_CONTNO) {
        if (type == "Normal") {
          this.isLoading = true;
        }
        payload = {
          itemCode: "getWehbhookLog",
          fk_all_module_id: this.PMC_JOBID,
          containerNo: this.PMC_CONTNO,
          type: type,
        };

        CommonService.getAllJobList(payload)
          .then((response) => {
            const { data, status, statusText } = response;
            console.log();
            if (status == 200 && data.FLAG == 1) {
              if (type == "Excell") {
                if (data.webLog.length > 0) {
                  this.ContainerList = data.webLog;
                }

                this.ExcelBtnName = "Export As Excel";
                window.location.href =
                  `https://uploadsp.pridel.com/Pridel_Reports/` + data.excelName;
              } else {
                if (data.webLog.length > 0) {
                  this.ContainerList = data.webLog;
                }
              }
            }
            this.isLoading = false;
          })
          .catch((error) => {
            console.log("Catch on ContainerList Error: ", error);
          });
      }
    },

    showContainerModal(allModuleId) {
      this.ContainerList = [];
      this.$refs["Container-modal"].show();
      this.getContainer("Normal");
      // this.isLoading = false;
    },
    hideContainerModal() {
      this.ContainerList = [];
      this.$refs["Container-modal"].hide();
      // this.isLoading = false;
    },
  },
};
</script>
<style>
.my-custom-scrollbar {
  position: relative;
  height: 550px;
  overflow: auto;
}
.my-custom-scrollbar_xAxis {
  position: relative;
  height: 340px;
  overflow: auto;
}
.table-wrapper-scroll-y {
  display: block;
}
.alert-danger-text {
  /* background-color: #d9534f; Bootstrap danger color */
  color: #d9534f; /* Bootstrap danger color */
}
@keyframes blink {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
}

.blink {
  animation: blink 1s infinite; /* Adjust the duration as needed */
}
.full-screen-modal .modal-dialog {
  max-width: 100vw;
  width: 100%;
  height: 100vh;
  margin: 0;
}

.full-screen-modal .modal-content {
  height: 100%;
  border: none;
  border-radius: 0;
}
</style>



// WEBPACK FOOTER //
// moduleBasedContaierWebLogSummary.vue?0bde08ff